module.exports = __webpack_public_path__ + "static/media/yuntaishan2.17505dd0.webp";